import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 200 200",
  style: {"width":"100%","height":"100%"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M79.9 122.6c-.2-.2-.6-.6-.8-1-9-11.7-24.4-33.7-27.7-52.7-.6-3.8-.6-6.3-.6-6.5-.1-13.4 5.2-26 15-35.5 9.4-9.1 21.8-14.1 35-14.1s25.7 5 35.1 14.1c9.7 9.4 15 21.9 14.9 35.2 0 .3 0 2.7-.6 6.8-3.1 17.8-16.7 38.3-27.5 52.5-.3.5-.6.8-.8 1.1-6.7 8.2-13.6 14-15.2 15.4-.2.2-.3.3-.4.3l-5.3 4.2-5.3-4.2c-.5-.2-8.1-6.4-15.8-15.6zm43.7-56.1c0-12.1-10.1-21.9-22.6-21.9s-22.6 9.8-22.6 21.9 10 21.9 22.6 21.9c12.4 0 22.6-9.8 22.6-21.9zm-94.2 84.3h141.1c10.7 0 19.5 8 19.4 18.2 0 10.2-8.7 18.2-19.4 18.2H47c-3.4.1-6.2-2.7-6.2-6.1s2.8-6.1 6.2-6.1h123.5c4.1 0 7.1-2.8 7.1-6s-3.1-6-7.1-6h-141c-10.6 0-19.4-8-19.4-18.2s8.7-18.2 19.4-18.2h22.1c3.4-.1 6.2 2.7 6.2 6.1 0 3.4-2.8 6.1-6.2 6.1H29.4c-4.1 0-7.1 2.8-7.1 6s3.1 6 7.1 6z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    class: "tri-icon",
    style: _normalizeStyle(`font-size: ${_ctx.size}; color: ${_ctx.color}; width: 1em; height: 1em; display:block; line-height: 0;`)
  }, [
    (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
  ], 4))
}